import { i18next, utils as sdkUtils } from '@yola/ws-sdk';
import utils from 'src/js/modules/utils';
import isGoogleMapsShortLink from '../helpers/is-google-maps-short-link';
import isSameOrigin from '../helpers/is-same-origin';

const normalizeIframeUrl = (url) => url.trim();

const hasMultipleProtocols = (value) => {
  const matches = value.match(/[a-z][a-z0-9+.-]*:\/\//gi);

  return matches && matches.length > 1;
};

const createIframeUrlValidator = () => (value) => {
  const normalizedValue = normalizeIframeUrl(value);

  if (!sdkUtils.validation.isURL(normalizedValue) || isGoogleMapsShortLink(normalizedValue)) {
    return i18next.t('Please enter valid URL');
  }

  if (hasMultipleProtocols(normalizedValue)) {
    return i18next.t('Please enter valid URL');
  }

  if (isSameOrigin(normalizedValue)) {
    return i18next.t('Please enter valid URL');
  }

  const validateRequired = utils.validators.createRequiredValidator(
    i18next.t('Please enter valid URL')
  );

  return validateRequired(normalizedValue);
};

export default createIframeUrlValidator;
export { normalizeIframeUrl };
